import React, { useEffect } from 'react';
import { sanitize } from 'utils/validation';
import { ANALYTICS } from 'constants';
import MODAL from 'constants/modals';
import LoadingWidget from 'components/LoadingWidget';
import PrintButtonModal from 'components/Modal/PrintButtonModal';
import propTypes from './PrepayTermsPropTypes';

const PrepayTerms = ({ getPrepayTerms, prepayTerms, classNames = '', showPrintButton }) => {
  useEffect(() => {
    if (!prepayTerms) {
      getPrepayTerms();
    }
  }, [prepayTerms, getPrepayTerms]);

  return (
    <div className='padding-top--condensed pre-pay-terms__content--position'>
      {prepayTerms ? (
        <>
          <PrintButtonModal
            showPrintButton={showPrintButton}
            analyticsTitle={ANALYTICS.PREPAYMENT_TERMS_CONDITIONS}
            customCss='.pre-pay-terms__overlay'
          />
          <div
            id={`${MODAL.PREPAY_TERMS_CONDITIONS_MODAL}_desc`}
            className={classNames}
            dangerouslySetInnerHTML={sanitize(prepayTerms)}
          />
        </>
      ) : (
        <LoadingWidget />
      )}
    </div>
  );
};

PrepayTerms.propTypes = propTypes;

export default PrepayTerms;
